export default class Global {
    constructor() {
        this.smoothScroll();
    }

    smoothScroll() {
        const buttons = document.querySelectorAll('.smooth-scroll');

        buttons.forEach(function (el, i) {
            el.addEventListener('click', function (ev) {
                ev.preventDefault();

                let item = document.querySelector(el.getAttribute('href'));

                window.scrollTo({
                    'behavior': 'smooth',
                    'left': 0,
                    'top': item.offsetTop
                });
            });
        });
    }
}
